export default __webpack_public_path__ + "static/media/sinon.7730d36d.png";